<template>
  <NuxtLink
    :link="props.link"
    class="btn btn--more"
    :class="{'button-more--disabled': props.disabled}"
    @click="onClick">
    <span class="">{{ props.label }}</span>
  </NuxtLink>
</template>

<script setup lang="ts">
const emits = defineEmits(['click'])

const onClick = () => {
  if (!props.disabled) {
    emits('click')
  }
}
const props = defineProps({
  link: {type: String, required: false},
  label: {type: String, required: false},
  disabled: {type: Boolean, required: false, default: false},
})
</script>
